import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogFooter,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { useState } from "react"
import { useUpdatePatient } from "@/services/query/patients.query"
import { Pencil } from "lucide-react"

export function EditPatientDialog({ patient, open, onOpenChange, onClose }) {
  const [formData, setFormData] = useState({
    user_name: patient.user_name,
    phone_number: patient.phone_number,
  })
  const updatePatientMutation = useUpdatePatient()

  const handleSubmit = async (e) => {
    e.preventDefault()
    await updatePatientMutation.mutateAsync({
      patientId: patient.thread_id,
      data: formData,
    })
    onOpenChange(false)
    onClose()
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Edit Patient</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
          <div className="grid gap-2">
            <Label htmlFor="edit-name">Patient Name</Label>
            <Input
              id="edit-name"
              value={formData.user_name}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  user_name: e.target.value,
                }))
              }
              required
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="edit-phone">Phone Number</Label>
            <Input
              id="edit-phone"
              type="tel"
              value={formData.phone_number}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  phone_number: e.target.value,
                }))
              }
              required
            />
          </div>
          <DialogFooter>
            <Button
              type="submit"
              disabled={updatePatientMutation.isPending}
            >
              {updatePatientMutation.isPending ? "Saving..." : "Save Changes"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}
